import A from './types';

const init = () => ({
  hasFocus: ('hidden' in window.document) ? !window.document.hidden : true,
  globalParams: {}
});

const reducer = (state, action) => {
  switch (action.type) {
    case A.WINDOW_FOCUSED: {
      return {
        ...state,
        hasFocus: true,
      };
    }
    case A.WINDOW_BLURRED: {
      return {
        ...state,
        hasFocus: false,
      };
    } case A.GLOBAL_PARAMS: {
      return {
        ...state,
        globalParams: action.payload
      }
    }
  }
  return null;
};

export default {reducer, init};



// WEBPACK FOOTER //
// ./src/modules/window/reducer.js